import { Box } from '@mui/material';
import type { TypographyProps } from '@mui/material';
import type { UseFormReturn } from 'react-hook-form';
import { UserInfoForm } from './user-info.form';
import { DeleteUserForm } from './delete-user.form';
import type { UpdateUser } from './general-tab.types';

interface GeneralTabProps {
  form: UseFormReturn<UpdateUser>;
  tabTitle?: TypographyProps;
  onSubmit: () => void;
  onCancel: () => void;
}

const GeneralTab = ({ form, onSubmit, onCancel }: GeneralTabProps) => {
  return (
    <Box component="form">
      <Box sx={{ maxWidth: 600, mx: 'auto' }}>
        <UserInfoForm form={form} onSubmit={onSubmit} onCancel={onCancel} />
        <DeleteUserForm />
      </Box>
    </Box>
  );
};

export default GeneralTab;
